export default function CTAFinale() {
  return (
    <section className="cta-finale">
      <div className="container">
        <div className="cta-finale__card">
          <h2>
            Prêt à devenir visible sur Google<br />
            et à recevoir de nouveaux clients chaque jour ?
          </h2>
          <p>
            Rendez-vous et devis 100% gratuits, sans engagement. On prend le
            temps de vous écouter et on vous dit exactement ce dont vous avez
            besoin — rien de plus, rien de moins.
          </p>
          <a href="#reservation" className="btn-primary">
            Créer mon premier site web →
          </a>
          <p className="cta-finale__guarantee">
            <span>✓</span> Rendez-vous et Devis 100% Gratuits. Sans Engagement.
          </p>
        </div>
      </div>
    </section>
  );
}
